import { css } from "@emotion/css";

const styles = {
  icon: css`
    width: 17px !important;
    height: 17px !important;
  `,
};

export default styles;
